export default __webpack_public_path__ + "static/char-s-11-en-9e0ee0253b1653f6fb6a29a3a1814bc1.png";